import React, { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';

import RsiAbove70Component from '../components/RsiAbove70Component';



const RsiAbove70: React.FC = () => {
  const {
    user
   } = useUserContext();

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

 // const [user, setUser] = useState({token : '', uuid: '', email: '', userType: '', subscriptionFreeUntil: 0, pricing : "" });
 

  // Authentication check query
//   const { isError: isAuthError } = useQuery(
//     'authCheck',
//     async () => {
//       // Updated to use the new API endpoint structure
//       const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard`, {
//         method: 'GET',
//         credentials: 'include',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         throw new Error('Not authenticated');
//       }

//       const data = await response.json();
// console.log("Dashboard:", data)
//       // Check if response follows the standardized format
//       if (!data.success) {
//         throw new Error(data.message || 'Authentication failed');
//       }

//       return data.data; // Return the actual data from the standardized response
//     },
//     {
//       onError: () => {
//         // Redirect to login page on authentication error
//         navigate('/login');
//       },
//       retry: false, // Don't retry auth check on failure
//     }
//   );



  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  // if (isLoading) {
  //   return (
  //     <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 flex items-center justify-center">
  //       <div className="p-4 text-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-main mx-auto mb-4"></div>
  //         <p className="text-lg">Loading dashboard data...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6">
  //       <div className="bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 p-4 rounded-lg mb-6">
  //         <p>Error loading dashboard data. Please try again later.</p>
  //       </div>
  //       <button
  //         onClick={() => window.location.reload()}
  //         className="px-4 py-2 bg-primary-main text-white rounded-md hover:bg-primary-dark"
  //       >
  //         Retry
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <div className="flex">
          <main className="flex-1 p-0">
            <header className="mb-6">
              <h1 className="text-2xl font-bold">RSI Above 70</h1>
              {/* <h1 className="text-xs" style={{ margin: 0, paddingTop: 5, color: 'gray' }}>{user?.email }</h1>
              <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray' }}>{'Subscription until: ' + new Date(user?.subscriptionFreeUntil).toLocaleString(undefined, { hour12: true })}</h1> */}

            </header>

          {/* {user.email ?
         <CloseToLowestPricesComponent user={user}/>
          : null } */}

         {user?.email  && user.userType == "ADMIN" ?
          <RsiAbove70Component user={user} />
          : null }
          {/* <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b">Coin</th>
                <th className="py-2 px-4 border-b">Price (USD)</th>
                <th className="py-2 px-4 border-b">5-Day Progress</th>
              </tr>
            </thead>
            <tbody>
              {coins?.map((coin: any) => (
                <tr key={coin.id}>
                  <td className="py-2 px-4 border-b flex items-center">
                    <img src={coin.image} alt={coin.name} className="w-6 h-6 mr-2" />
                    {coin.name}
                  </td>
                  <td className="py-2 px-4 border-b">${coin.current_price.toLocaleString()}</td>
                  <td className="py-2 px-4 border-b">
                    <div className="flex items-center">
                      {coin.sparkline_in_7d.price.slice(-5).map((price: number, index: number) => (
                        <div
                          key={index}
                          className="h-2 w-2 rounded-full mx-1"
                          style={{ backgroundColor: price >= coin.current_price ? 'green' : 'red' }}
                        ></div>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> */}
        </main>
      </div>
    </div>
  );
};

export default RsiAbove70;
